import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerVisit } from 'src/app/core/interfaces/customer-visit';
import { ApiService } from 'src/app/core/services/api/api.service';
import { IdbService } from 'src/app/core/services/idb/idb.service';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { RoleService } from 'src/app/core/services/role/role.service';

@Component({
  selector: 'app-sent-to-inside-sales-list',
  templateUrl: './sent-to-inside-sales-list.component.html',
  styleUrls: ['./sent-to-inside-sales-list.component.scss'],
})
export class SentToInsideSalesListComponent implements OnInit {
  sentToInsideSalesDisplayedColumns: string[] = [
    'customerVisitId',
    'createdDate',
    'statusName',
    'customerName',
    'jobAddress',
    'dispositionName',
    'subDispositionName',
    'dispositionNotes',
    'dispositionDate',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSourceArray: CustomerVisit[] = [];
  sentToInsideSalesDataSource: MatTableDataSource<CustomerVisit>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private local: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.sentToInsideSalesDataSource = new MatTableDataSource();
    this.getSentToInsideSalesData();
  }

  getSentToInsideSalesData() {
    let estimatorName = this.local.get('name');
    this.apiService.getCustomerVisitsSentToInsideSales(estimatorName).subscribe(
      (data: CustomerVisit[]) => {
        this.isLoading = false;
        this.dataSourceArray = data;
        this.sentToInsideSalesDataSource = new MatTableDataSource(
          this.dataSourceArray
        );
        this.sentToInsideSalesDataSource.paginator = this.paginator;
        this.sentToInsideSalesDataSource.sort = this.sort;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  goToCustomerVisit(row: CustomerVisit) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        customerVisitId: row.customerVisitId,
        online: true,
        insideSales: true,
        estimator: true,
      },
    });
  }

  filterCustomerVisits(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.sentToInsideSalesDataSource.filter = filterString.trim().toLowerCase();
  }
}
